import { getFeatureConfig } from '@luna/feature-config';
import type { Language } from '@luna/i18n';
import { isFeatureEnabled } from '@luna/gatekeeper';
import { dangerouslyMutateFeatureConfig } from '@retail/feature-config';

export function getAllowedLanguages(): Language[] {
    const allowedLanguages = getFeatureConfig((config) => config.base.allowedLanguages);

    if (isFeatureEnabled((f) => f.syntheticLanguages)) {
        return [
            ...allowedLanguages,
            ...(getFeatureConfig((config) => config.base.supportedSyntheticLanguages) ?? []),
        ] as Language[];
    }

    return allowedLanguages;
}

export function isLanguageAllowed(language: Language): boolean {
    return getAllowedLanguages().includes(language);
}

export function setCzCurrencySignByLanguage(language: Language): void {
    if (getFeatureConfig((featureConfig) => featureConfig.base.country) !== 'CZ') {
        return;
    }

    const isLanguageEn = language === 'en';

    dangerouslyMutateFeatureConfig(
        getFeatureConfig((featureConfig) => featureConfig),
        (featureConfig) => {
            featureConfig.base.defaultCurrencySign = isLanguageEn ? 'CZK' : 'Kč';
            featureConfig.base.useSalutation = !isLanguageEn;
        },
    );
}
